import { render, staticRenderFns } from "./MasterLayout.vue?vue&type=template&id=1d96c470&scoped=true&"
import script from "./MasterLayout.vue?vue&type=script&lang=js&"
export * from "./MasterLayout.vue?vue&type=script&lang=js&"
import style0 from "./MasterLayout.vue?vue&type=style&index=0&id=1d96c470&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d96c470",
  null
  
)

export default component.exports